import { render, staticRenderFns } from "./ConversationTypesReport.vue?vue&type=template&id=3d1a49b4&scoped=true"
import script from "./ConversationTypesReport.vue?vue&type=script&lang=js"
export * from "./ConversationTypesReport.vue?vue&type=script&lang=js"
import style0 from "./ConversationTypesReport.vue?vue&type=style&index=0&id=3d1a49b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1a49b4",
  null
  
)

export default component.exports